export default __webpack_public_path__ + "static/media/Claims-assisted.f7866493.svg";